import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';



import React, { useState, useEffect } from 'react';

import AgeVerificationForm from '../forms/AgeVerification';
import FormCreateAccount from '../forms/CreateAccount';
import LoginForm from '../forms/Login';


interface VerificationProps {
    submit: (value: boolean) => void;

    /* Passthrough */
    updatecsrf: (value: string) => void;
    updatesession: (value: string) => void;
}

function UserVerifyPage({submit, updatecsrf, updatesession}: VerificationProps){

    const [pageIndex, setPageIndex] = useState(0)
    const [viewVerify, setViewVerify] = useState(true);
    const [viewLogin, setViewLogin] = useState(false);
    const [viewSignup, setViewSignup] = useState(false);

    const reset = () => {
        setViewVerify(false);
        setViewLogin(false);
        setViewSignup(false);
    }
    const signup = () => {
        reset();
        setViewSignup(true)
        setPageIndex(1)
    }

    const login = () => {
        reset();
        setViewLogin(true)
        setPageIndex(2)
    }

    const verify = () => {
        reset();
        setViewVerify(true)
        setPageIndex(0)
    }

    /* Component Init */
    useEffect(() => {
        
    }, [viewVerify, viewLogin, viewSignup]);

    return (
        <> 
            <Row className="">
                <Col md={{span: 6, offset: 3}}>
                    <p className="text-font-body text-font-size-small text-font-heavy text-start">Age Verification:</p>
                    <p className="text-font-body text-font-size-tiny text-font-light text-start">By using our services, you confirm that you are at least <strong>21</strong> years of age and possess the legal capacity to enter into binding agreements. We reserve the right to implement age verification measures, including requesting proof of age or using third-party identity verification services, to ensure compliance with applicable laws and regulations. If we determine that a user does not meet the minimum age requirement, we may suspend or terminate their account and delete associated personal data. Parents or legal guardians who believe their minor has provided us with personal information should contact us immediately so that we can take appropriate action.</p>
                </Col>
            </Row>
            <Row className="">
                <Col md={{ span: 4, offset: 4 }}>
                    <Row>
                    <Col className="p-0">
                        <input className={viewVerify ? "input-fill btn brand-btn-tertiary-color" : "input-fill btn brand-btn-primary-color" } type="button" value="Continue as guest" onClick={verify} />
                    </Col>
                    <Col className="p-0">
                        <input className={viewSignup ? "input-fill btn brand-btn-tertiary-color" : "input-fill btn brand-btn-primary-color" } type="button" value="Create Account" onClick={signup} />
                    </Col>
                    <Col className="p-0">
                        <input className={viewLogin ? "input-fill btn brand-btn-tertiary-color" : "input-fill btn brand-btn-primary-color" } type="button" value="Sign In" onClick={login} />
                    </Col>
                    </Row>
                </Col>
            </Row>
            { viewVerify &&
                <Row>
                    <Col md={{ span: 4, offset: 4 }}><AgeVerificationForm submit={submit} /></Col>
                </Row>
            }
            { viewSignup &&
                <Row>
                    <Col md={{ span: 6, offset: 3 }}><FormCreateAccount updatecsrf={updatecsrf} updatesession={updatesession} /></Col>
                </Row>
            }
            { viewLogin &&
                <Row>
                    <Col md={{ span: 4, offset: 4 }}><LoginForm updatecsrf={updatecsrf} updatesession={updatesession} /></Col>
                </Row>
            }
        </>
    )
}

export default UserVerifyPage;